import { render, staticRenderFns } from "./CountDown.vue?vue&type=template&id=24803714&"
import script from "./CountDown.vue?vue&type=script&lang=js&"
export * from "./CountDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24803714')) {
      api.createRecord('24803714', component.options)
    } else {
      api.reload('24803714', component.options)
    }
    module.hot.accept("./CountDown.vue?vue&type=template&id=24803714&", function () {
      api.rerender('24803714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/CountDown.vue"
export default component.exports